module.exports = __webpack_public_path__ + "img/eyebrow_female_arched_average_mask.6a41f22f.png";